<template lang="html">
  <root class="admin-orders">

    <admin-nav></admin-nav>
    <page-header name="Orders" :count="total"></page-header>

    <!-- Data -->
    <div class="container">

      <!-- Tool Box -->
      <div style="display:inline-flex;">
        <input v-model="searchText" type="text" placeholder="Search by Phone" v-on:keyup.enter="onSearchEnter" style="width:250px; margin-right:5px;"/>
        <a @click="search()" class="toolBox" title="Search by Phone" style="width:50px; height:25px; margin-top:15px;">Search</a>
        <a v-if="showClearButton" class="toolBox" @click="clear()" title="Clear" style="width:40px; height:25px; margin-left:5px; margin-top:15px;">Clear</a>
      </div>

      <!-- Data -->
      <div class="datable">
        <datatable class="striped" v-bind="$data" :HeaderSettings="false" :Pagination="false" :PageSizeOptions="[2, 5,10, 20, 40, 80, 100]"/>
      </div>
      
      <!-- Pagination -->
      <div v-if="total > 0 & showPagination & totalPages > 1" style="width:100%; padding-top:5px; padding-bottom: 20px;">
        <div style="float:left">
          <a class="pagination" @click="previous()" title="PREVIOUS">Previous</a>
          <a class="pagination" @click="next()" title="NEXT">Next</a>
        </div>
        <div style="float:right">{{page}}/{{totalPages}} page(s)</div>
      </div>

    </div>

    <preloader :is-active="!items.length"></preloader>
  </root>
</template>

<script>
import * as firebase from "firebase";
import pageState from "../../plugins/page-state";
import orderOpt from "./Operations/OrderOpt.vue";
import utils from "../../plugins/utilities";
const purify = (x) => JSON.parse(JSON.stringify(x));

export default {
  data() {
    return {
      isLanguageArabic: this.$route.params.lang == "ar",
      items: [],
      data: [],
      columns: [
        { title: "Key", field: "key", visible: false },
        { title: "UID", field: "uid" },
        { title: "Status", field: "status", sortable: true },
        { title: "Business", field: "businessName" },
        { title: "Phone", field: "phone" },
        { title: "Amount", field: "amount" },
        { title: "Instant", field: "instant" },
        { title: "Actions", tdComp: orderOpt },
      ],
      page: 1,
      total: 0,
      query: {
        limit: 10,
        direction: "next",
        offset: 0,
        sort: "timestamp",
        order: "",
      },
      nextKey: null,
      nextCreatedAt: null,
      nextItem: null,
      previousKey: null,
      previousCreatedAt: null,
      previousItem: null,
      searchText: null,
      showPagination: true,
      showClearButton: false,
    };
  },
  computed: {
    totalPages() {
      return utils.calculateNumberOfPages(this.total, this.query.limit);
    },
  },
  methods: {
    // Get the whole total of items from Firebase
    getItemsTotal() {

      var dashboard = pageState.getItem("Dashboard");
      this.total = dashboard.orders.count;

      //#region old
      // firebase
      //   .database()
      //   .ref("orders")
      //   .once("value")
      //   .then((itemsSnap) => {
      //     this.total = itemsSnap.numChildren();
      //   });
      //#endregion
    },
    // Collect items
    collectItems() {
      let self = this;
      self.items = [];

      var firebaseQuery = null;

      if (self.query.direction == "next") {
        //#region Next
        if (self.nextKey == null) {
          firebaseQuery = firebase
            .database()
            .ref("orders")
            .orderByChild("timestamp")
            .limitToLast(self.query.limit + 1)
            .once("value");
        } else {
          firebaseQuery = firebase
            .database()
            .ref("orders")
            .orderByChild("timestamp")
            .endAt(self.nextCreatedAt, self.nextKey)
            .limitToLast(self.query.limit + 1)
            .once("value");
        }
        //#endregion
      } else {
        //#region Previous
        firebaseQuery = firebase
          .database()
          .ref("orders")
          .orderByChild("timestamp")
          .startAt(self.previousCreatedAt, self.previousKey)
          .limitToFirst(self.query.limit + 1)
          .once("value");
        //#endregion
      }

      firebaseQuery.then((itemsSnap) => {
        var resultItemsNumber = itemsSnap.numChildren();

        var currentIndex = 0;
        // Loop through Items
        itemsSnap.forEach((itemSnap) => {
          let itemData = itemSnap.val();

          //Store next item to be able to go further
          if (currentIndex == 0) {
            self.nextCreatedAt = itemData.timestamp;
            self.nextKey = itemSnap.key;
            self.nextItem = itemSnap;

            //console.log("Next Item");
            //console.log(purify(self.nextItem));
          }

          //Process Business
          if (
            currentIndex > 0 ||
            (currentIndex == 0 && resultItemsNumber <= self.query.limit)
          ) {
            this.processItem(itemSnap);
          }

          currentIndex++;
        });

        this.data = this.items.reverse();

        //Get previous item to be able to go back
        this.storePreviousItem();
      });
    },
    processItem(itemSnap) {
      let itemData = itemSnap.val();

      // Key
      itemData["key"] = itemSnap.key;

      // User Key
      itemData["user_key"] = itemData.user_key;

      // Phone
      itemData["phone"] = "+" + itemData.phone;

      // Status
      itemData["status"] = _.upperFirst(itemData.status);

      // Instant
      itemData["instant"] = itemData.is_instant ? "Yes" : "No";
      
      // Business name
      firebase
        .database()
        .ref("businesses/" + itemData.business.key)
        .once("value")
        .then((businessSnap) => {
          let businessData = businessSnap.val();
          if (businessData != null) {
            itemData.businessName = businessData.name.en;
          }

          // Push
          this.items.push(itemData);
        });
    },
    previous() {
      if (this.page >= 2) {
        this.query.direction = "previous";
        this.page--;
        if (this.query.offset >= 0) {
          this.query.offset -= this.query.limit;
        }
        this.collectItems();
      } else {
        console.log("Idle");
      }
    },
    next() {
      if (this.page < utils.specialRoundUp(this.total / this.query.limit)) {
        this.query.direction = "next";
        this.page++;
        if (this.query.offset <= this.total) {
          this.query.offset += this.query.limit;
        }
        this.collectItems();
      } else {
        console.log("Idle");
      }
    },
    storePreviousItem() {
      //#region Get and store previous item to be able to go back afterwards
      let self = this;

      if (self.data.length > 0) {
        var itemData = self.data[0];

        //console.log("Previous Item");
        //console.log(purify(itemData));

        self.previousCreatedAt = itemData.timestamp;
        self.previousKey = itemData.key;
        self.previousItem = itemData;
      }
      //#endregion
    },
    onSearchEnter() {
      this.search();
    },
    search() {
      if (this.searchText != null) {
        var searchObject = this.searchText
          .replace(/\s/g, "")
          .trim()
          .toLowerCase();

        this.showClearButton = true;
        this.showPagination = false;
        this.data = [];
        this.items = [];

        var firebaseQuery = firebase
          .database()
          .ref("orders")
          .orderByChild("phone")
          .equalTo(searchObject)
          .once("value");

        firebaseQuery.then((itemsSnap) => {
          if (purify(itemsSnap) != null) {
            //#region Search Results

            this.total = itemsSnap.numChildren();
            // Loop through Items
            itemsSnap.forEach((itemSnap) => {
              this.processItem(itemSnap);
            });
            this.data = this.items;

            //#endregion
          }
        });
      }
    },
    clear() {
      this.items = [];
      this.data = [];
      this.page = 1;
      this.total = 0;
      this.query = {
        limit: 10,
        direction: "next",
        offset: 0,
        sort: "timestamp",
        order: "",
      };
      this.searchText = null;
      this.nextKey = null;
      this.nextCreatedAt = null;
      this.nextItem = null;
      this.previousKey = null;
      this.previousCreatedAt = null;
      this.previousItem = null;
      this.showClearButton = false;
      this.showPagination = true;
      this.query.direction = "next";
      this.getItemsTotal();
      this.collectItems();
    },
  },
  beforeRouteLeave(to, from, next) {
    pageState.backup(next, this.$router.currentRoute);
  },
  mounted() {
    this.getItemsTotal();
    this.collectItems();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Admin/Orders.vue